import React from 'react';

const Logo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  return (
    <img 
      src="/lovable-uploads/a24b420b-3da0-4f29-8ab0-51a4f33f1e45.png"
      alt="ALTA-X Logo"
      {...props}
    />
  );
};

export default Logo;
